import {quest1} from "./quests/quest_1";
import {quest2} from "./quests/quest2";
import {quest3} from "./quests/quest_3";
import {quest4} from "./quests/quest_4";
import {quest5} from "./quests/quest_5";
import {quest6} from "./quests/quest_6";
import {quest7} from "./quests/quest_7";

export const chapter3 =
    {
        title: "Функция жанра повседневность",
        quests: [

            quest1,
            quest2,
            quest3,
            quest4,
            quest5,
            quest6,
            quest7,
        ]
    };